import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { isModuleApproved } from "../../../routes/ModuleRouter";
// import Sidenav from "../../../components/Sidenav";
// import { hasModule } from "../../../constants/user";
import { getLandingPage } from "../../../constants/roles";
import AppLayout from "../../../components/Layout";
import NotFound from "../../../components/NotFound";
import Redirect from "../../../components/Redirect";
import { hasModule } from "../../../constants/user";

function CADD({ authentication: { user }, match }) {
  // add default route if we need
  const location = useLocation();
  const landingPage = getLandingPage({ user, module: 'cadd' });
  if (user && !isModuleApproved(user, 'cadd') && !location.pathname === '/app/cadd/profile') {
    return <Redirect to="/app/cadd/profile?create" />
  }

  if (location.pathname === '/app/cadd' && landingPage.indexOf('/cadd') > -1 && landingPage !== location.pathname) {
    return <Redirect to={landingPage} />;
  }

  if (hasModule(user, 'cadd')) {
    return <AppLayout
      match={match}
      module="cadd"
    />
  }

  return <NotFound />
}

export default connect(({ authentication }) => ({ authentication }))(CADD);
